export default __webpack_public_path__ + "static/media/j.26e145c8.png";